import {Injectable} from '@angular/core';
import {Observable, Subscriber} from 'rxjs';
import {LogEntry} from '../../shared/model/log-entry';
import {LogEntryFilter} from '../../shared/model/log-entry-filter';
import { HttpClient, HttpResponse } from '@angular/common/http';
import {environment} from '../../../environments/environment';
import {ProtocolAsCsv} from '../model/log-csv';
import { saveAs } from 'file-saver';

@Injectable()
export class LogService {

  constructor(public _http: HttpClient) {
  }

  /**
   * Get a pre-filtered list of all log entries
   * @param {LogEntryFilter} filter The (optional) filter to pre-filter the list
   * @returns {Observable<LogEntry[]>}
   */
  getLogEntries(filter?: LogEntryFilter): Observable<LogEntry[]> {
    return new Observable<LogEntry[]>((subscriber: Subscriber<LogEntry[]>) => {
      this._http.post(environment.endpoints.clientBaseUrl + environment.endpoints.protocolList, filter)
        .subscribe(
          (logEntries: LogEntry[]) => {
            subscriber.next(logEntries);
            subscriber.complete();
          },
          (error: any) => {
            subscriber.error(error);
          }
        );
    });
  }

  downloadLogProtocol(filter: LogEntryFilter): Observable<any> {
    return new Observable((subscriber: Subscriber<any>) => {
      this._getLogEntriesAsCsv(filter)
        .subscribe(
          (protocolInfo: ProtocolAsCsv) => {

            saveAs(protocolInfo.data, protocolInfo.fileName);
            subscriber.next(protocolInfo);
          },
          (error: any) => {
            subscriber.error(error);
          }
        );
    });
  }

  private _getLogEntriesAsCsv(filter: LogEntryFilter): Observable<ProtocolAsCsv> {
    return new Observable<ProtocolAsCsv>((subscriber: Subscriber<ProtocolAsCsv>) => {
      this._http.post(environment.endpoints.clientBaseUrl + environment.endpoints.protocolListAsCsv, filter, {
        responseType: 'blob',
        observe: 'response'
      })
        .subscribe(
          (response: HttpResponse<Blob>) => {
            // Get filename
            let fileName = response.headers.get('Content-Disposition');
            fileName = fileName.split('=')[1];

            subscriber.next({data: response.body, fileName: fileName});
            subscriber.complete();
          },
          (error: any) => {
            subscriber.error(error);
          }
        );
    });
  }
}
